import type { RouteLocationNormalizedLoadedGeneric } from 'vue-router'

import type { UserLoadingStrategy } from '../types'

import { findRouteOrParentMatchingPredicate } from './findRouteOrParentMatchingPredicate'
import { getRouteAuth } from './getRouteAuth'

/**
 * Determines the userLoadingStrategy value based on route meta and app config.
 * Route meta takes precedence over app config.
 *
 * Exception: `guest-magic-link` routes always resolve to `'never'`. The magic-link
 * middleware (`useGuestMagicLink`) owns the user loading (token exchange then
 * `fetchUser`), so the plugin must never compete with it — regardless of route
 * meta or app config.
 */
export function getUserLoadingStrategy(
  route: RouteLocationNormalizedLoadedGeneric,
  appUserLoadingStrategy: UserLoadingStrategy,
): UserLoadingStrategy {
  if (getRouteAuth(route)?.mode === 'guest-magic-link') return 'never'

  const matchedRouteWithUserLoadingStrategy =
    findRouteOrParentMatchingPredicate(
      route,
      (routeDefinition) =>
        !!(routeDefinition.meta && routeDefinition.meta.userLoadingStrategy),
    )

  return (
    (matchedRouteWithUserLoadingStrategy?.meta?.userLoadingStrategy as
      | UserLoadingStrategy
      | undefined) || appUserLoadingStrategy
  )
}
